import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import { RiRadarLine } from 'react-icons/ri';
import { withNamespaces } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import ComplianceScreeningService from 'src/modules/3rd-party-management/apis/admin/compliance/screening/ScreeningService';
import { toast } from 'react-toastify';

const StartComplianceScreeningModal = ({
    show,
    onClose,
    selectedRows,
    t
}) => {
    const {
        mutate: startScreeningMutation,
        isLoading: startScreeningLoading
    } = useMutation({
        mutationFn: async (payload) => {
            const service = ComplianceScreeningService.getInstance();

            return await service.startScreeningBusiness(payload);
        },
        onSuccess: () => {
            toast(t("Compliance screening completed successfully for {{count}} third-party(ies).", {
                count: selectedRows.length
            }), {
                type: "success"
            });

            onClose();
        },
        onError: ({ response }) => {
            const {
                data: errorData
            } = response || {};

            if (errorData?.error === 'insufficient_credit_kyb') {
                toast(t('Failed to start compliance screening for the selected businesses due to insufficient KYB {{creditLabel}}. Please top up your balance and try again.', {
                    creditLabel: 'credit'
                }), {
                    type: "error"
                });
            }
            else {
                toast(t("Failed to start compliance screening for the selected third-party(ies)."), {
                    type: "error"
                });
            }
        }
    });

    const handleConfirm = () => {
        startScreeningMutation({
            supplier_ids: selectedRows.map(row => row.id)
        });
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center justify-content-start">
                    <RiRadarLine className="me-2 text-primary" size={22} />
                    {t('Start {{complianceType}}', {
                        complianceType: 'Compliance Screening'
                    })}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <p className="mb-3">
                    {t('You are about to start compliance screening for the selected third-party(ies).')}
                </p>

                <Alert variant="light" className="border">
                    <strong>{selectedRows.length}</strong> {t('{{count}} third-party(ies) will be added to screening.', {
                        count: ''
                    })}
                </Alert>
            </Modal.Body>

            <Modal.Footer>

                <Button
                    variant="light"
                    onClick={onClose}
                    disabled={startScreeningLoading}
                >
                    {t('Cancel')}
                </Button>

                <Button
                    variant="primary"
                    onClick={handleConfirm}
                    disabled={startScreeningLoading}
                >
                    {startScreeningLoading ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            {t('Starting Screening')}...
                        </>
                    ) : t("Start Screening")}
                </Button>

            </Modal.Footer>
        </Modal>
    );
}

export default withNamespaces()(
    StartComplianceScreeningModal
);